
import React from 'react';
import autoBind from 'react-autobind'
import Navigation from '../components/Navigation';



class NavigationFixed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      opacityLayerTransition: true,
    };
    autoBind(this);
  }

  handleClose(){
    setTimeout(() => this.setState({opacityLayerTransition: true}), 500);
    this.setState({open: false});
  }
  handleOpen(){
    this.setState({opacityLayerTransition: false});
    this.setState({open: true});
  }

  render() {
    const opacityLayerStateDisplay = this.state.opacityLayerTransition ? "navigationFixedDisplayNone" : "navigationFixedDisplayBlock";
    const navState = this.state.open ? "navigationFixedWrapperOpen" : "navigationFixedWrapperClose";
    const opacityLayerState = this.state.open ? "navigationFixedOpacityLayerOpen" : "navigationFixedOpacityLayerClose";
    
    return (
      <div>
        <div className={"navigationFixedWrapper "+ navState}>
         
          <div className="navigationFixedNavigationWrapper">
            <div className="navigationFixedNavigation">
              <Navigation onClose={()=>{setTimeout(() =>{this.handleClose()}, 600)}} />
              
            </div>
          </div>
           <div className={"navigationFixedCloseNav "+ navState}>
            <div onClick={this.handleClose} className="navigationFixedCloseButtonWrapper">
              <img alt="closeW" className="navigationFixedCloseButton" src="../assets/icons/closeW.png"/>
            </div>
          </div>
        </div>
        <div 
          onClick={this.handleClose}
          className={opacityLayerStateDisplay+ " navigationFixedOpacityLayer " +opacityLayerState} 
        />
      </div>
    );
  }
}


export default NavigationFixed;



// WEBPACK FOOTER //
// ./src/components/NavigationFixed.js